<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
@media screen and (min-width: 700px) {
  #app {
    width: 390px !important;
    margin: 0 auto;
  }
  .van-overlay,
  .van-popup--bottom,
  .van-popup--top {
    width: 390px !important;
    left: calc(50% - 195px) !important;
  }
}

#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}
</style>
